import { z } from "zod";

import { DatabaseIdentity } from "@/core/api";
import { DateIsoString } from "@/core/types";
import { Attachment } from "@/data/attachments";
import { ConsultantProfileContactPerson } from "@/data/consultant-profiles/types/ConsultantProfileContactPerson";
import { WorkStyle } from "@/data/consultant-profiles/types/WorkStyle";
import { JobApplicationStatus } from "@/data/job-applications/types/JobApplicationStatus";
import { UserBase } from "@/data/users";
import { UserCompanyRole } from "@/data/users/types/UserCompanyRole";

export const ConsultantProfile = z
  .object({
    contactPerson: ConsultantProfileContactPerson,
    availabilityDate: DateIsoString.nullable(),
    availability: z.string().nullable(),
    cvs: z.array(Attachment),
    parent: DatabaseIdentity.nullable(),
    position: z
      .object({
        name: z.string().nullable(),
      })
      .nullable(),
    draftApplicationId: z.number().nullish(),
    applicationCount: z.number().nullish(),
    firstApplicationStatus: JobApplicationStatus.nullish(),
    companyRole: UserCompanyRole.nullable(),
    workStyles: z.array(WorkStyle).nullish(),
  })
  .merge(UserBase)
  .passthrough();

export type ConsultantProfile = z.infer<typeof ConsultantProfile>;
